import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import H2Regular from "../h2-regular";
import { getDynamicContent } from "../../../utils/helpers/category-helper";

const CarBuyingGuide = ({  dynamicContent = {}, categories = [], selectedCategory = "" }) => {
    const { h2, h2Body } = getDynamicContent({dynamicContent, categories, selectedCategory });
    return (
        <React.Fragment>
            {h2 && <div styleName={"styles.outer"}>
                <div className="container">
                    <H2Regular text={h2} />
                    <div styleName={"styles.contentWrap"}>
                        {
                            (h2Body || []).map((data, key) =>
                                (<p key={key} styleName={"styles.content"}>
                                    {data}
                                </p>)
                            )
                        }
                    </div>
                </div>
            </div>}
        </React.Fragment>
    );
};

export default CarBuyingGuide;

CarBuyingGuide.propTypes = {
    dynamicContent: PropTypes.object,
    categories: PropTypes.array,
    selectedCategory: PropTypes.object
};
